module.exports = __webpack_public_path__ + "img/bootstrap_startup.532bab4c.svg";